const currentStoreContainer1 = document.querySelector('.current-store-container-1');
const video = document.querySelector(".popUp-open-text-video");
const cVid = document.querySelector("#current-video");
const overlay1 = document.querySelector(".popUp-overlay-1");
const closeBtn1 = document.querySelector(".popUp-close-1");
const formVi = document.querySelector('#videoForm');
const v123 = document.querySelector('#myVideo123');

function verVideoss(){
  video.style.display = 'inline';
}

function handlePopUp1() {
    if (overlay1.classList.contains('hidden-pop')) {
        overlay1.classList.remove('hidden-pop');
        overlay1.classList.add('open-pop');
    } else {
        overlay1.classList.remove('open-pop');
        overlay1.classList.add('hidden-pop');
    }
}

function playVideo() {
  if (v123.paused) {
      v123.play();
  }
}

if(closeBtn1){
  closeBtn1.addEventListener('click', () => {
      handlePopUp1()
    if (!v123.paused) {
        v123.pause();
    }
  });
}

window.addEventListener("load", () => {
  currentStoreContainer1 && currentStoreContainer1.classList.remove('hidden-pop');
})

cVid && cVid.addEventListener('click', handlePopUp1);
cVid && cVid.addEventListener('click', playVideo);